<template>
  <div class="addLabel">
    <div class="tips">
      <div class="tipNav overflow">
        <img class="hornIcon mr5 fl" src="../images/hornIcon.png" />
        <div class="fl">为了更好的给您匹配政策，请您添加标签哦</div>
      </div>
    </div>
    <div class="content">
      <div v-for="(item, index) in content" :key="index">
        <div v-if="item.tagFormat == 'date'">
          <van-field
            style="border-bottom:1px solid #ebedf0"
            is-link
            input-align="right"
            readonly
            clickable
            name="datetimePicker"
            :value="item.value"
            :label="item.tagName"
            placeholder="请选择"
            @click="item.showPicker = true"
          />
          <van-popup round v-model="item.showPicker" position="bottom">
            <van-datetime-picker
              v-model="currentDate"
              type="date"
              title="请选择"
              :formatter="formatter"
              @confirm="onConfirm($event, item, index)"
              :min-date="minDate"
              :max-date="maxDate"
              @cancel="item.showPicker = false"
            />
          </van-popup>
        </div>
        <van-collapse v-model="activeName" accordion>
          <van-collapse-item
            v-if="item.tagFormat == 'list'"
            :title="item.tagName"
            :value="data[index].tagOptionValue"
            :name="item.id"
          >
            <div class="label_content">
              <span
                :class="[
                  item.radioFlag == it.id + '_' + it.tagId ? 'radioActive' : ''
                ]"
                @click="changeRadio(index, it)"
                v-for="(it, idx) in item.tagOptions"
                :key="idx"
              >
                {{ it.optionValue }}
              </span>
            </div>
          </van-collapse-item>
          <van-collapse-item
            v-if="item.tagFormat == 'multiple'"
            :title="item.tagName"
            :name="item.id"
            :value="data[index].tagOptionValue"
          >
            <div class="label_content">
              <span
                :class="[it.checked == 1 ? 'radioActive' : '']"
                @click="changeCheck(index, it)"
                v-for="(it, idx) in item.tagOptions"
                :key="idx"
              >
                {{ it.optionValue }}
              </span>
            </div>
          </van-collapse-item>
        </van-collapse>

        <van-field
          style="border-bottom:1px solid #ebedf0"
          v-if="item.tagFormat == 'float'"
          is-link
          input-align="right"
          v-model="item.value"
          :name="item.tagName"
          :label="item.tagName"
          @input="changeInput($event, index)"
          :placeholder="'请输入' + item.tagName"
        />
      </div>
    </div>
    <div class="footer_fixed">
      <van-button color="#6D90E2" @click="toAutoMatch" type="primary" block
        >去匹配</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "",
      minDate: new Date(1920, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      data: [],
      content: []
    };
  },
  methods: {
    getlabel() {
      this.$http.home
        .getlabel({
          pageSize: 100
        })
        .then(res => {
          let content = res.data.pageInfo.content;
          this.data = content.map(item => {
            if (item.tagFormat == "list" || item.tagFormat == "multiple") {
              return {
                tagId: item.id,
                tagOptionId: "",
                tagOptionValue: ""
              };
            } else {
              return {
                tagId: item.id,
                tagValue: ""
              };
            }
          });
          this.content = content.map(item => {
            if (item.tagFormat == "list") {
              item.radioFlag = "";
              return item;
            } else if (item.tagFormat == "multiple") {
              item.tagOptions.map(res => {
                res.checked = 0;
              });
              return item;
            } else {
              item.value = "";
              item.showPicker = false;
              return item;
            }
          });
        });
    },
    formatter(type, val) {
      if (type === "year") {
        return val + "年";
      }
      if (type === "month") {
        return val + "月";
      }
      if (type === "day") {
        return val + "日";
      }
      return val;
    },
    // 日期类型
    onConfirm(time, item, index) {
      console.log(time, item, index);
      var d = new Date(time);
      var datetime =
        d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
      item.value = datetime;
      this.data[index].tagValue = item.value;
      item.showPicker = false;
    },
    //单选
    changeRadio(index, it) {
      this.content[index].radioFlag = it.id + "_" + it.tagId;
      this.data[index].tagOptionId = it.id;
      this.data[index].tagOptionValue = it.optionValue;
    },
    //多选
    changeCheck(index, it) {
      let arr = [],
        ids = [];
      if (it.checked == 0) {
        this.$set(it, "checked", 1);
      } else {
        this.$set(it, "checked", 0);
      }
      this.content[index].tagOptions.forEach(item => {
        if (item.checked == 1) {
          arr.push(item.optionValue);
          ids.push(item.id);
        }
      });
      this.data[index].tagOptionId = ids.join(",");
      this.data[index].tagOptionValue = arr.join(",");
    },
    // 数值
    changeInput(val, index) {
      this.data[index].tagValue = val;
    },
    // 确认
    toAutoMatch() {
      let tips = "";
      for (var index = 0; index < this.content.length; index++) {
        let item = this.content[index];
        if (item.tagFormat == "date" && item.value == "") {
          tips = "请选择" + item.tagName;
          break;
        } else if (item.tagFormat == "list" || item.tagFormat == "multiple") {
          if (this.data[index].tagOptionValue == "") {
            tips = "请选择" + item.tagName;
            break;
          }
        } else if (item.tagFormat == "float") {
          if (item.value == "") {
            tips = "请输入" + item.tagName;
            break;
          }
        }
      }
      if (tips) {
        this.$toast(tips);
      } else {
        this.$router.push("/autoMatch");
        localStorage.setItem("H_rct_data", JSON.stringify(this.data));
        localStorage.setItem("H_rct_content", JSON.stringify(this.content));
      }
    }
  },
  created() {
    if (
      localStorage.getItem("H_rct_data") &&
      localStorage.getItem("H_rct_content")
    ) {
      this.data = JSON.parse(localStorage.getItem("H_rct_data"));
      this.content = JSON.parse(localStorage.getItem("H_rct_content"));
    } else {
      this.getlabel();
    }
  }
};
</script>
<style lang="less" scoped>
.addLabel {
  padding-bottom: 80px;
  padding-top: 40px;
  // background: #fff;
  .tips {
    position: fixed;
    top: 5px;
    left: 0;
    right: 0;
    z-index: 2;
    border-radius: 16px 16px 4px 4px;
    border: 1px solid #e5e5e5;
    border-bottom: none;
  }
}
.tipNav {
  height: 20px;
  background: linear-gradient(
    180deg,
    rgba(0, 191, 105, 0.18) 0%,
    rgba(0, 191, 105, 0) 100%
  );
  padding: 10px 15px;
  .hornIcon {
    width: 24px;
    height: 24px;
  }
  div {
    font-size: 15px;
    color: #00bf69;
    line-height: 24px;
  }
}
.content {
  padding: 0 15px;
  .label_content {
    background: #f8f9fb;
    padding: 5px;
    span {
      // background: #ffffff;
      border-radius: 4px;
      border: 1px solid #dde0d8;
      padding: 4px 8px;
      font-size: 14px;
      color: #515359;
      margin-right: 10px;
      display: inline-block;
      margin: 5px;
    }
    .radioActive {
      color: #6d90e2;
      border: 1px solid #6d90e2;
    }
  }
}
.footer_fixed {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 15px 15px 20px 15px;
}
/deep/.van-cell__title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/deep/.van-cell__value {
  flex: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/deep/.van-collapse-item__content {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/addlabel.vue